import { render, staticRenderFns } from "./SiteVersionMentionInput.vue?vue&type=template&id=c0789de8&scoped=true&"
import script from "./SiteVersionMentionInput.vue?vue&type=script&lang=js&"
export * from "./SiteVersionMentionInput.vue?vue&type=script&lang=js&"
import style0 from "./SiteVersionMentionInput.vue?vue&type=style&index=0&id=c0789de8&prod&lang=scss&"
import style1 from "./SiteVersionMentionInput.vue?vue&type=style&index=1&id=c0789de8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0789de8",
  null
  
)

export default component.exports